import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Helmet} from "react-helmet";
import './style.scss';
import SecondaryNav from '../../general/SecondaryNav';
import {getStatutoryInfoDetailContent, clearInformationDetail} from './actions';
import NoContent from '../../general/NoContent';

class StatutoryInfoDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoNodeId: '',
      errors: '',
    }
    this.errors={}
  }

  componentDidMount = () => {
    this.loadHandler();
    window.scrollTo(0,0);
  };
  // eslint-disable-next-line react/sort-comp
  componentWillUnmount() {
    this.props.clearInformationDetail();
  }
  componentWillReceiveProps(nextProps) {
    const {getStatutoryInfoDetailContent, informationDetail, history: {
        location
      }} = this.props;
    let nodeId = nextProps.location.pathname.split('/');
    if (this.state.infoNodeId != "" && this.state.infoNodeId != nodeId[nodeId.length - 1]) {
      getStatutoryInfoDetailContent({}, nodeId[nodeId.length - 1]);
      this.setState({
        infoNodeId: nodeId[nodeId.length - 1]
      })
    }
  }

  loadHandler = async () => {
    const {getStatutoryInfoDetailContent, location: {
        pathname
      }} = this.props;
    let nodeId = pathname.split('/');
    // if(Object.keys(this.props.informationDetail).length==0 ){
    await getStatutoryInfoDetailContent({}, nodeId[nodeId.length - 1]);
    this.setState({
      infoNodeId: nodeId[nodeId.length - 1]
    })
    // }

  };
  render() {
    const {informationDetail} = this.props;

    return (
     informationDetail && <div className="information">
      {
        informationDetail && informationDetail.meta && <Helmet>
            <title>{informationDetail.meta.title}</title>
            <meta name="description" content={informationDetail.meta.description}/>
            <meta property="og:title" content={informationDetail.meta.og_title}/>
            <meta property="og:description" content={informationDetail.meta.og_description}/>
          </Helmet>
      }
      <SecondaryNav {...this.props} title={informationDetail.title} className='new-website'/>
      <div className="scheme-banner">
        {/* <h1 className="container-930">{informationDetail.title}</h1> */}
      </div>
      {
        informationDetail.head != null
            ? <div className="product-content container" dangerouslySetInnerHTML={{
              __html: informationDetail.head
            }} />
            : ""
      }
      {
        informationDetail.image != null
          ? <div className='container'><img src={informationDetail.image} alt="image" className='mt-4' /></div> 
          : ''
      }
      {
        informationDetail.body != null
          ? <div className="product-content container" dangerouslySetInnerHTML={{
                __html: informationDetail.body
              }} />
          : <NoContent />
      }

    </div>)
  }
}
const mapStateToProps = (state) => (
  {
    commonContent: state.commonContent,
    informationDetail: state.statutoryInformation,
  });

const mapDispatchToProps = (dispatch) => ({
  getStatutoryInfoDetailContent: bindActionCreators(getStatutoryInfoDetailContent, dispatch),
  clearInformationDetail: bindActionCreators(clearInformationDetail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatutoryInfoDetail);
